import { useHiddenMode } from '../contexts/HiddenModeContext';

export const useHiddenFields = () => {
  const { isHiddenModeActive } = useHiddenMode();

  // Define which fields should be hidden by default
  const hiddenFields = {
    // AddBooking page fields
    booking: {
      chargesAmount: !isHiddenModeActive,
      otherWorkAmount: !isHiddenModeActive,
      terraceAmount: !isHiddenModeActive,
      banakhatAmount: !isHiddenModeActive,
      remarks: !isHiddenModeActive,
    },
    
    // Role/Permission management
    permissions: {
      broker: !isHiddenModeActive,
      expense: !isHiddenModeActive,
      otherIncome: !isHiddenModeActive,
      partner: !isHiddenModeActive,
    }
  };

  return {
    isHiddenModeActive,
    hiddenFields,
    // Helper function to check if a specific field should be hidden
    isFieldHidden: (category: keyof typeof hiddenFields, field: string) => {
      const categoryFields = hiddenFields[category] as Record<string, boolean>;
      return categoryFields[field] || false;
    }
  };
};

export default useHiddenFields;
